import { VStack } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { mq } from '../../../../../common/src/utils/styledComponentsUtils';

// Components
import OfferDocuments from '../../offers/OfferDocuments';

// Types
import { LouiseOffer } from '../../../../../../types/Quotes';
import SingleSelectedOfferActions from './SingleSelectedOfferActions';
import SingleSelectedOfferPrice from './SingleSelectedOfferPrice';
import SingleSelectedOfferForm from './SingleSelectedOfferForm';
import { isSocialLoginUrl } from '../../../../../app/src/features/authentication/constants/SocialAuth';

interface Props {
  offer: LouiseOffer;
  riskObject: string;
}

const SingleSelectedOfferSummary: React.FC<React.PropsWithChildren<Props>> = ({
  offer,
  riskObject,
}) => {
  const { t } = useTranslation();

  const documents = [
    {
      label: t('TERMS'),
      url: offer.info.terms || '',
    },
    {
      label: t('IPID'),
      url: offer.info.ipid || '',
    },
  ];

  return (
    <>
      <VStack
        spacing={{ laptop: '4' }}
        borderLeft="1px"
        borderColor="gray.50"
        padding={{ laptop: 4 }}
        maxWidth={{ laptop: '64' }}
        w="100%"
        align="stretch"
      >
        <VStack align="stretch" p={{ base: 4, laptop: 0 }}>
          <SingleSelectedOfferPrice offer={offer} />
          <SingleSelectedOfferForm offer={offer} />
        </VStack>
        <VStack spacing={{ laptop: '4' }} align="stretch">
          {!isSocialLoginUrl && (
            <GrayContainer>
              <h3>{t('Documents')}</h3>
              <OfferDocuments documents={documents} />
            </GrayContainer>
          )}

          <SingleSelectedOfferActions offer={offer} />
        </VStack>
      </VStack>
    </>
  );
};

const GrayContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.gray[50]};
  &:last-child {
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  > h3 {
    margin-bottom: 1.2rem;
  }

  &:first-child {
    display: none;
    ${mq.laptop} {
      display: block;
    }
  }

  ${mq.laptop} {
    border: none;
    background-color: #f7f8fb;
    border-radius: 6px;
    padding: 1.6rem;
  }
`;

export default SingleSelectedOfferSummary;
